import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  Drawer,
  FormControlLabel,
  IconButton,
  Typography,
} from "@mui/material";
import useColors from "api/hooks/useColors";
import { useState } from "react";

const InternalDashboardWidgetSelector = ({ widgets, onToggleWidget }) => {
  const colors = useColors();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open) => {
    setDrawerOpen(open);
  };

  const removableWidgets = widgets.filter((widget) => widget.isRemovable);

  return (
    <>
      <Button
        onClick={() => toggleDrawer(true)}
        startIcon={<AddIcon />}
        sx={{
          background: colors.common_white,
          color: colors.action_active,
          height: "32px",
          border: "1px solid " + colors.enabled_stroke,
          borderRadius: "8px",
          textTransform: "none",
          whiteSpace: "nowrap",
          "&:hover": {
            background: colors.grey_8percent,
          },
        }}
      >
        Add Widget
      </Button>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => toggleDrawer(false)}
      >
        <Box
          sx={{
            width: 350,
            padding: "24px",
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "16px",
            }}
          >
            <Typography variant="h6">Select Widgets</Typography>
            <IconButton onClick={() => toggleDrawer(false)} size="small">
              <CloseIcon />
            </IconButton>
          </Box>

          <Divider sx={{ marginBottom: "16px" }} />

          <Box sx={{ flex: 1, overflowY: "auto" }}>
            {removableWidgets.map((widget) => (
              <FormControlLabel
                key={widget.id}
                control={
                  <Checkbox
                    checked={widget.isVisible}
                    onChange={() => onToggleWidget(widget.id)}
                    sx={{
                      color: colors.primary_main,
                      "&.Mui-checked": {
                        color: colors.primary_main,
                      },
                    }}
                  />
                }
                label={<Typography variant="body2">{widget.title}</Typography>}
                sx={{ marginBottom: "8px", display: "flex", width: "100%" }}
              />
            ))}
          </Box>
        </Box>
      </Drawer>
    </>
  );
};

export default InternalDashboardWidgetSelector;
